export const context = {
    strong: "À quoi sert l'url du planning ?",
    paragraph1: {
        text: "Cette URL permet de synchroniser vos calendriers avec des outils comme {0} sur Mac OS, ou {1} sur Windows.",
        em1: "Calendrier",
        em2: "Outlook"
    },
    paragraph2: "Pour la précédente version, nous avions réalisé cette vidéo qui expliquait comment effectuer cette synchronisation. Si l'interface desdits outils n'a pas changé, cela devrait encore fonctionner 😊."
}